import styles from "./CreateShow.module.scss";
import React, { useEffect, useState } from "react";
import { withRouter, useRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import { Add, Remove } from "@mui/icons-material";
import {
  Button,
  Snackbar,
  Alert,
  Dialog,
  DialogContentText,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  FormControl,
  Fab,
  FormLabel,
  Grid,
  Typography,
  Box,
  CircularProgress,
  InputAdornment,
} from "@mui/material";
import { ShowInterface } from "../../../models/Show";
import { Show } from "../../../models/createShow/Show";
import Image from "next/image";
import {
  createShow,
  editShow,
} from "../../../services/ShowService";
import { ShootingLocations } from "../../../models/ShootingLocation";
import { ShowTemplateType } from "../../../../enums/ShowTemplates";
import { InputContentVariable, ShowTemplates, TemplateInterface, emptyInputContentVariable } from "../../../models/Template";
import TemplateInput from "./TemplateInput/TemplateInput";
import { replaceDate, timeSpanToDays } from "../../../utils/dates";
import ShootingLocationInput from "./ShootingLocationInput/ShootingLocationInput";
import { DesktopDatePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { defaultInitialFillPercentageStr } from "src/utils/constants";

interface CreateShowProps extends WithRouterProps {
  onSuccess: Function;
  type?: string | undefined;
  templates?: TemplateInterface[]
}

const CreateShow: React.FC<CreateShowProps> = ({
  onSuccess,
  type,
  templates
}) => {
  class CreateShowViewModel {
    show: Show;
    showTemplates: any;
    image: any;
    objectURL: any;
    termsAndConditions: any;
    termsAndConditionsObjURL: any;
    termsAndConditionsKey: any;
    validationErrors: any;
    constructor({ show }: any) {
      this.show = show;
    }
  }

  const [snackbarErrorOpen, setSnackbarErrorOpen] = React.useState(false);
  const [snackbarSuccessOpen, setSnackbarSuccessOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [dialogTitle, setDialogTitle] = React.useState("");
  const [submitMessage, setSubmitMessage] = React.useState("");
  const [successMessage, setSuccessMessage] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const router = useRouter();

  const [viewModel, setViewModel] = useState(
    new CreateShowViewModel({ show: new Show() })
  );
  const [showName, setShowName] = React.useState("");
  const [synopsis, setSynopsis] = React.useState("");
  const [networkName, setNetworkName] = React.useState("");
  const [productionCompany, setProductionCompany] = React.useState("");
  const [initialFillPercentage, setInitialFillPercentage] = React.useState(defaultInitialFillPercentageStr);
  const [minAgeRequirement, setMinAgeRequirement] = React.useState("");
  const [ticketingStartTimeOffset, setTicketingStartTimeOffset] = React.useState("");
  const [url, setUrl] = React.useState("");
  const [shootingLocations, setShootingLocations] = React.useState<ShootingLocations>(null);
  const [showLaunchDate, setShowLaunchDate] = React.useState<dayjs.Dayjs | null>(null);
  const [showLaunchTime, setShowLaunchTime] = React.useState<dayjs.Dayjs | null>(null);

  const [firstEmailTemplate, setFirstEmailTemplate] = React.useState("");
  const [reminderEmailTemplate, setReminderEmailTemplate] = React.useState("");
  const [confirmEmailTemplate, setConfirmEmailTemplate] = React.useState("");
  const [groupEmailTemplate, setGroupEmailTemplate] = React.useState("");
  const [ticketEmailTemplate, setTicketEmailTemplate] = React.useState("");
  const [confirmSmsTemplate, setConfirmSmsTemplate] = React.useState("");
  const [reminderSmsTemplate, setReminderSmsTemplate] = React.useState("");

  const [firstEmailTemplateSubject, setFirstEmailTemplateSubject] = React.useState("");
  const [reminderEmailTemplateSubject, setReminderEmailTemplateSubject] = React.useState("");
  const [confirmEmailTemplateSubject, setConfirmEmailTemplateSubject] = React.useState("");
  const [groupEmailTemplateSubject, setGroupEmailTemplateSubject] = React.useState("");
  const [ticketEmailTemplateSubject, setTicketEmailTemplateSubject] = React.useState("");
  const [confirmSmsTemplateSubject, setConfirmSmsTemplateSubject] = React.useState("");
  const [reminderSmsTemplateSubject, setReminderSmsTemplateSubject] = React.useState("");

  const emptyContentJson = JSON.stringify(emptyInputContentVariable)
  const [firstEmailTemplateContent, setFirstEmailTemplateContent] = React.useState(emptyContentJson);
  const [reminderEmailTemplateContent, setReminderEmailTemplateContent] = React.useState(emptyContentJson);
  const [confirmEmailTemplateContent, setConfirmEmailTemplateContent] = React.useState(emptyContentJson);
  const [groupEmailTemplateContent, setGroupEmailTemplateContent] = React.useState(emptyContentJson);
  const [ticketEmailTemplateContent, setTicketEmailTemplateContent] = React.useState(emptyContentJson);
  const [confirmSmsTemplateContent, setConfirmSmsTemplateContent] = React.useState(emptyContentJson);
  const [reminderSmsTemplateContent, setReminderSmsTemplateContent] = React.useState(emptyContentJson);

  const [submitDisabled, setSubmitDisabled] = React.useState(false);
  const [showNameError, setShowNameError] = React.useState(false);
  const [networkNameError, setNetworkNameError] = React.useState(false);
  const [termsAndConditionsError, setTermsAndConditionsError] = React.useState(false);
  const [productionCompanyError, setProductionCompanyError] =
    React.useState(false);
  const [initialFillPercentageError, setInitialFillPercentageError] = React.useState(false);
  const [urlError, setUrlError] = React.useState(false);
  const [shootingLocationsError, setShootingLocationsError] = React.useState(false);
  const [ticketingStartTimeOffsetError, setTicketingStartTimeOffsetError] = React.useState(false);
  const [showLaunchDateError, setShowLaunchDateError] = React.useState(false);
  const [showLaunchTimeError, setShowLaunchTimeError] = React.useState(false);

  const [loadingAssets, setLoadingAssets] = React.useState(false);

  const clearForm = () => {
    setShowName("");
    setSynopsis("");
    setNetworkName("");
    setProductionCompany("");
    //setInitialFillPercentage("");
    setMinAgeRequirement("");
    setTicketingStartTimeOffset("");
    setUrl("");
    setShowNameError(false);
    setShowLaunchDateError(false);
    setShowLaunchTimeError(false);
    setNetworkNameError(false);
    setProductionCompanyError(false);
    setInitialFillPercentageError(false);
    setUrlError(false);
    setTicketingStartTimeOffsetError(false);
    removeImage();
    removeTermsAndConditions();
    setFirstEmailTemplate("")
    setFirstEmailTemplateContent(emptyContentJson)
    setFirstEmailTemplateSubject("")
    setReminderEmailTemplate("")
    setReminderEmailTemplateContent(emptyContentJson)
    setReminderEmailTemplateSubject("")
    setConfirmEmailTemplate("")
    setConfirmEmailTemplateContent(emptyContentJson)
    setConfirmEmailTemplateSubject("")
    setGroupEmailTemplate("")
    setGroupEmailTemplateContent(emptyContentJson)
    setGroupEmailTemplateSubject("")
    setTicketEmailTemplate("")
    setTicketEmailTemplateContent(emptyContentJson)
    setTicketEmailTemplateSubject("")
    setConfirmSmsTemplate("")
    setConfirmSmsTemplateContent(emptyContentJson)
    setConfirmSmsTemplateSubject("")
    setReminderSmsTemplate("")
    setReminderSmsTemplateContent(emptyContentJson)
    setReminderSmsTemplateSubject("")
    setShootingLocations(null)
    setShowLaunchDate(null)
    setShowLaunchTime(null)
  };

  useEffect(() => {
    setSubmitDisabled(
      showName === "" ||
      networkName === "" ||
      synopsis === "" ||
      productionCompany === "" ||
      //initialFillPercentage === "" ||
      url === "" ||
      ticketingStartTimeOffset === "" ||
      shootingLocations === null ||
      shootingLocations?.length === 0 ||
      showLaunchDate === null ||
      showLaunchTime === null
    );
  }, [showName, synopsis, networkName, productionCompany, initialFillPercentage, url, ticketingStartTimeOffset, shootingLocations, showLaunchTime, showLaunchDate]);


  useEffect(() => {
    if (router?.asPath.includes("create-show")) {
      setOpen(true);

      setDialogTitle("Create New Show");
      setSubmitMessage("Create Show");
      setSuccessMessage("Show Successfully Created!");
      setErrorMessage("Show Creation Failed!");
    }
    if (router?.asPath.includes("edit-show")) {
      setOpen(true);
      setDialogTitle("Edit Show");
      setSubmitMessage("Update Show");
      setSuccessMessage("Show Successfully Updated!");
      setErrorMessage("Show Update Failed!");

      prePopulateForm();
    }
  }, [router]);

  const handlePostShow = (values: any) => {
    setLoading(true);

    setViewModel({
      ...viewModel,
    });

    const showTemplates: ShowTemplates = [
      {
        showTemplateType: ShowTemplateType.FirstEmailTemplate, templateId: templates?.find(t => t.name == firstEmailTemplate)?.id, inputContentVariablesJson: firstEmailTemplateContent, subject: firstEmailTemplateSubject
      },
      {
        showTemplateType: ShowTemplateType.ReminderEmailTemplate, templateId: templates?.find(t => t.name == reminderEmailTemplate)?.id, inputContentVariablesJson: reminderEmailTemplateContent, subject: reminderEmailTemplateSubject
      },
      {
        showTemplateType: ShowTemplateType.ConfirmEmailTemplate, templateId: templates?.find(t => t.name == confirmEmailTemplate)?.id, inputContentVariablesJson: confirmEmailTemplateContent, subject: confirmEmailTemplateSubject
      },
      {
        showTemplateType: ShowTemplateType.GroupEmailTemplate, templateId: templates?.find(t => t.name == groupEmailTemplate)?.id, inputContentVariablesJson: groupEmailTemplateContent, subject: groupEmailTemplateSubject
      },
      {
        showTemplateType: ShowTemplateType.TicketEmailTemplate, templateId: templates?.find(t => t.name == ticketEmailTemplate)?.id, inputContentVariablesJson: ticketEmailTemplateContent, subject: ticketEmailTemplateSubject
      },
      {
        showTemplateType: ShowTemplateType.ConfirmSmsTemplate, templateId: templates?.find(t => t.name == confirmSmsTemplate)?.id, inputContentVariablesJson: confirmSmsTemplateContent, subject: confirmSmsTemplateSubject
      },
      {
        showTemplateType: ShowTemplateType.ReminderSmsTemplate, templateId: templates?.find(t => t.name == reminderSmsTemplate)?.id, inputContentVariablesJson: reminderSmsTemplateContent, subject: reminderSmsTemplateSubject
      }];

    const editShowMatch = router?.asPath?.match(/edit-show=(\d+)/);
    const isEdit = !!editShowMatch;
    const editShowId = editShowMatch ? Number(editShowMatch[1]) : undefined;

    let show: ShowInterface = {
      id: editShowId,
      name: showName,
      synopsis: synopsis,
      showTemplatesJSON: JSON.stringify(showTemplates),
      defaultInitialFillPercentage: Number(initialFillPercentage),
      defaultMinimumAgeRequirement: Number(minAgeRequirement),
      defaultTicketingStartTimeOffset: ticketingStartTimeOffset,
      networkName: networkName,
      productionCompany: productionCompany,
      publicRouteUrL: url,
      shootingLocationsJSON: JSON.stringify(shootingLocations),
      termsAndConditions: viewModel.termsAndConditions instanceof Blob ? viewModel.termsAndConditions : null,
      termsAndConditionsKey: viewModel.termsAndConditions instanceof Blob ? null : (viewModel.termsAndConditionsKey ?? null),
      image: viewModel.image instanceof Blob ? viewModel.image : null,
      imageUrl: viewModel.image instanceof Blob ? null : (viewModel.objectURL ?? null),
      showLaunch: replaceDate(showLaunchTime, showLaunchDate)?.toJSON(),
    };

    if (isEdit) {
      editShow(show).then((res) => {
        if (res.status == 200) {
          setOpen(false);
          setLoading(false);
          setSnackbarSuccessOpen(true);
          onSuccess();
        } else {
          setOpen(false);
          setLoading(false);
          setSnackbarErrorOpen(true);
        }
      });
      return;
    }
    createShow(show).then((res) => {
      if (res.showId) {
        setOpen(false);
        setLoading(false);
        setSnackbarSuccessOpen(true);
        router.push(`/show/${res.showId}`);
      } else {
        setOpen(false);
        setLoading(false);
        setSnackbarErrorOpen(true);
      }
    });

    clearForm();
  };

  const handleDialogClose = () => {
    setOpen(false);
    clearForm();
    router.replace(`/`, undefined, { shallow: true });
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarErrorOpen(false);
    setSnackbarSuccessOpen(false);
    setLoading(false);
  };

  const setTemplate = (prePopulateData: ShowInterface, templateName: string) => {
    var showTemplate = prePopulateData.showTemplates?.find((t: { showTemplateType: string; }) => t.showTemplateType == templateName)
    var template = templates?.find(t => t.id == showTemplate?.templateId)
    var content = showTemplate?.inputContentVariablesJson ? showTemplate?.inputContentVariablesJson : emptyContentJson
    switch (templateName) {
      case 'FirstEmailTemplate':
        setFirstEmailTemplate(template?.name!)
        setFirstEmailTemplateContent(content)
        setFirstEmailTemplateSubject(showTemplate?.subject!)
        break;
      case 'ReminderEmailTemplate':
        setReminderEmailTemplate(template?.name!)
        setReminderEmailTemplateContent(content)
        setReminderEmailTemplateSubject(showTemplate?.subject!)
        break;
      case 'ConfirmEmailTemplate':
        setConfirmEmailTemplate(template?.name!)
        setConfirmEmailTemplateContent(content)
        setConfirmEmailTemplateSubject(showTemplate?.subject!)
        break;
      case 'GroupEmailTemplate':
        setGroupEmailTemplate(template?.name!)
        setGroupEmailTemplateContent(content)
        setGroupEmailTemplateSubject(showTemplate?.subject!)
        break;
      case 'TicketEmailTemplate':
        setTicketEmailTemplate(template?.name!)
        setTicketEmailTemplateContent(content)
        setTicketEmailTemplateSubject(showTemplate?.subject!)
        break;
      case 'ConfirmSmsTemplate':
        setConfirmSmsTemplate(template?.name!)
        setConfirmSmsTemplateContent(content)
        setConfirmSmsTemplateSubject(showTemplate?.subject!)
        break;
      case 'ReminderSmsTemplate':
        setReminderSmsTemplate(template?.name!)
        setReminderSmsTemplateContent(content)
        setReminderSmsTemplateSubject(showTemplate?.subject!)
        break;
    }
  }

  const prePopulateForm = async () => {
    const sessionShowData = sessionStorage.getItem('prepopulateData');
    const prePopulateData = sessionShowData ? JSON.parse(sessionShowData) : null;

    if (prePopulateData) {
      setShowName(prePopulateData.name ? prePopulateData.name : "");
      setSynopsis(prePopulateData.synopsis ? prePopulateData.synopsis : "");
      setNetworkName(
        prePopulateData.networkName ? prePopulateData.networkName : ""
      );
      setProductionCompany(
        prePopulateData.productionCompany
          ? prePopulateData.productionCompany
          : ""
      );
      setShowLaunchDate(
        prePopulateData.showLaunch
          ? dayjs(prePopulateData.showLaunch)
          : null
      );
      setShowLaunchTime(
        prePopulateData.showLaunch
          ? dayjs(prePopulateData.showLaunch)
          : null
      );
      /*setInitialFillPercentage(
        prePopulateData.defaultInitialFillPercentage
          ? prePopulateData.defaultInitialFillPercentage
          : ""
      );*/
      setMinAgeRequirement(
        prePopulateData.defaultMinimumAgeRequirement
          ? prePopulateData.defaultMinimumAgeRequirement.toString()
          : ""
      );
      setTicketingStartTimeOffset(
        prePopulateData.defaultTicketingStartTimeOffset
          ? timeSpanToDays(prePopulateData.defaultTicketingStartTimeOffset)
          : ""
      );
      setUrl(
        prePopulateData.publicRouteUrL ? prePopulateData.publicRouteUrL : ""
      );
      setShootingLocations(
        prePopulateData.shootingLocations ? prePopulateData.shootingLocations : null
      );
      if (prePopulateData.showTemplates) {
        setTemplate(prePopulateData, "FirstEmailTemplate")
        setTemplate(prePopulateData, "ReminderEmailTemplate")
        setTemplate(prePopulateData, "ConfirmEmailTemplate")
        setTemplate(prePopulateData, "GroupEmailTemplate")
        setTemplate(prePopulateData, "TicketEmailTemplate")
        setTemplate(prePopulateData, "ConfirmSmsTemplate")
        setTemplate(prePopulateData, "ReminderSmsTemplate")
      }
      if (prePopulateData.imageUrl) {
        setViewModel((previousModel) => ({
          ...previousModel,
          objectURL: prePopulateData.imageUrl,
        }));
      }
      if (prePopulateData.hasTermsAndConditions) {
        setViewModel((previousModel) => ({
          ...previousModel,
          termsAndConditionsKey: prePopulateData.termsAndConditionsKey,
        }));
      }
    }
    setLoadingAssets(false);
  };

  const uploadToClient = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      const image = event.target.files[0];
      const objectURL = URL.createObjectURL(image);
      setViewModel({ ...viewModel, image, objectURL });
    }
  };

  const uploadTermsToClient = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      const termsAndConditions = event.target.files[0];

      if (termsAndConditions.type === 'application/pdf') {
        setTermsAndConditionsError(false)
        const termsAndConditionsObjURL = URL.createObjectURL(termsAndConditions);
        setViewModel({
          ...viewModel,
          termsAndConditions,
          termsAndConditionsObjURL,
        });
      } else {
        setErrorMessage("Please Add a PDF file");
        setSnackbarErrorOpen(true)
        setTermsAndConditionsError(true)
      }
    }
  };

  const removeImage = () => {
    setViewModel((previousModel) => ({
      ...previousModel,
      image: null,
      objectURL: null,
    }));
  };

  const removeTermsAndConditions = () => {
    setViewModel((previousModel) => ({
      ...previousModel,
      termsAndConditions: null,
      termsAndConditionsObjURL: null,
      termsAndConditionsKey: null,
    }));
  };

  const getEditShowWarningMessage = () => {
    const editWarningMessage =
      "Certain changes to show details (such as time, date and location) can have unexpected consequences. Please be careful when editing.";

    return (
      <DialogContentText
        sx={{
          p: '4px',
          marginBottom: '1.5rem',
          textAlign: 'center',
          borderStyle: 'solid',
          borderColor: 'red',
          borderRadius: '5px',
          fontWeight: 'bold',
          fontSize: '14px'
        }}>
        {editWarningMessage}
      </DialogContentText>
    )
  };

  return (
    <>
      <Dialog
        className={styles.createShow}
        open={open}
        onClose={handleDialogClose}
        fullWidth={true}
        maxWidth={"sm"}
        data-cy="createShowModal"
      >
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent className={styles.content}>
          {type === 'edit' ? (getEditShowWarningMessage()) : null}
          <TextField
            className={styles.input}
            label="Show Name"
            required
            error={showNameError}
            helperText={showNameError ? "Show name is mandatory." : ""}
            size="small"
            value={showName}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setShowName(event.target.value);
            }}
            onBlurCapture={() => {
              setShowNameError(showName === "");
            }}
            data-cy="modal-show-name"
          />
          <TextField
            className={styles.input}
            label="Synopsis"
            size="small"
            multiline
            required
            value={synopsis}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setSynopsis(event.target.value);
            }}
            data-cy="modal-show-synopsis"
          />
          <TextField
            className={styles.input}
            label="Network Name"
            required
            error={networkNameError}
            helperText={networkNameError ? "Network name is mandatory." : ""}
            size="small"
            value={networkName}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setNetworkName(event.target.value);
            }}
            onBlurCapture={() => {
              setNetworkNameError(networkName === "");
            }}
            data-cy="modal-show-networkName"
          />
          <TextField
            className={styles.input}
            label="Production Company"
            required
            error={productionCompanyError}
            helperText={
              productionCompanyError ? "Production company is mandatory." : ""
            }
            size="small"
            value={productionCompany}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setProductionCompany(event.target.value);
            }}
            onBlurCapture={() => {
              setProductionCompanyError(productionCompany === "");
            }}
            data-cy="modal-show-productionCompany"
          />
          <TextField
            className={styles.input}
            disabled
            label="Initial Fill Percentage"
            //required
            error={initialFillPercentageError}
            helperText={
              initialFillPercentageError ? "Initial fill percentage is mandatory." : ""
            }
            value={initialFillPercentage}
            size="small"
            type="number"
            inputProps={{
              min: 0,
              max: 100
            }}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setInitialFillPercentage(event.target.value);
            }}
            onBlurCapture={() => {
              setInitialFillPercentageError(initialFillPercentage === "");
            }}
            data-cy="modal-show-initialFillPercentage"
          />
          <Box sx={{ display: "flex", gap: "1rem" }}>
            <TextField
              className={styles.input}
              label="Minimum Age Requirement"
              value={minAgeRequirement}
              size="small"
              sx={{ label: { fontSize: "14px" } }}
              type="number"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setMinAgeRequirement(event.target.value);
              }}
            />
            <TextField
              className={styles.input}
              label="Ticketing Start Time Offset"
              required
              error={ticketingStartTimeOffsetError}
              helperText={
                ticketingStartTimeOffsetError ? "Ticketing Start Time Offset is mandatory." : ""
              }
              value={ticketingStartTimeOffset}
              size="small"
              sx={{ label: { fontSize: "14px" } }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setTicketingStartTimeOffset(event.target.value);
              }}
              onBlurCapture={() => {
                setTicketingStartTimeOffsetError(ticketingStartTimeOffset === "");
              }}
              data-cy="modal-show-ticketingStartTimeOffset"
              InputProps={{
                endAdornment: <InputAdornment position="end">days</InputAdornment>
              }}
            />
          </Box>
          <TextField
            className={styles.input}
            label="Public Route Url"
            required
            error={urlError}
            helperText={urlError ? "Public route urL is mandatory." : ""}
            size="small"
            value={url}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setUrl(event.target.value);
            }}
            onBlurCapture={() => {
              setUrlError(url === "");
            }}
            data-cy="modal-show-publicRouteUrl"
          />
          <Box sx={{ display: "flex", gap: "1rem" }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DesktopDatePicker
                value={showLaunchDate}
                onChange={(value) => {
                  setShowLaunchDate(value)
                }}
                className={styles.input}
                label="Show Launch Date"
                inputFormat="DD/MM/YYYY"
                disablePast
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    data-cy="modal-showLaunch-date-input"
                    error={showLaunchDateError}
                    helperText={showLaunchDateError ? "Show Launch Date is mandatory." : ""}
                    onBlur={() => {
                      setShowLaunchDateError(showLaunchDate === null);
                    }}
                  />
                )}
              />
              <TimePicker
                className={styles.input}
                label="Show Launch Time"
                value={showLaunchTime}
                onChange={(value) => {
                  setShowLaunchTime(value)
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    data-cy="modal-showLaunchTime-input"
                    error={showLaunchTimeError}
                    helperText={showLaunchTimeError ? "Show Launch Time is mandatory." : ""}
                    onBlur={() => {
                      setShowLaunchTimeError(showLaunchTime === null);
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </Box>
          <ShootingLocationInput
            value={shootingLocations}
            error={shootingLocationsError}
            helperText={shootingLocationsError ? "At least one shooting location is mandatory." : ""}
            onChange={(data: ShootingLocations) => {
              setShootingLocations(data);
              setShootingLocationsError(data == null || data.length < 1);
            }}
          />
          <TemplateInput
            key={1}
            name={ShowTemplateType.FirstEmailTemplate}
            mailType="BulkEmail"
            templates={templates}
            template={firstEmailTemplate}
            setTemplate={setFirstEmailTemplate}
            templateSubject={firstEmailTemplateSubject}
            setTemplateSubject={setFirstEmailTemplateSubject}
            templateContent={firstEmailTemplateContent}
            setTemplateContent={setFirstEmailTemplateContent}
            emptyContentJson={emptyContentJson}
          />

          <TemplateInput
            key={2}
            name={ShowTemplateType.ReminderEmailTemplate}
            mailType="BulkEmail"
            templates={templates}
            template={reminderEmailTemplate}
            setTemplate={setReminderEmailTemplate}
            templateSubject={reminderEmailTemplateSubject}
            setTemplateSubject={setReminderEmailTemplateSubject}
            templateContent={reminderEmailTemplateContent}
            setTemplateContent={setReminderEmailTemplateContent}
            emptyContentJson={emptyContentJson}
          />

          <TemplateInput
            key={3}
            name={ShowTemplateType.ConfirmEmailTemplate}
            mailType="Email"
            templates={templates}
            template={confirmEmailTemplate}
            setTemplate={setConfirmEmailTemplate}
            templateSubject={confirmEmailTemplateSubject}
            setTemplateSubject={setConfirmEmailTemplateSubject}
            templateContent={confirmEmailTemplateContent}
            setTemplateContent={setConfirmEmailTemplateContent}
            emptyContentJson={emptyContentJson}
          />

          <TemplateInput
            key={4}
            name={ShowTemplateType.GroupEmailTemplate}
            mailType="Email"
            templates={templates}
            template={groupEmailTemplate}
            setTemplate={setGroupEmailTemplate}
            templateSubject={groupEmailTemplateSubject}
            setTemplateSubject={setGroupEmailTemplateSubject}
            templateContent={groupEmailTemplateContent}
            setTemplateContent={setGroupEmailTemplateContent}
            emptyContentJson={emptyContentJson}
          />

          <TemplateInput
            key={5}
            name={ShowTemplateType.TicketEmailTemplate}
            mailType="Email"
            templates={templates}
            template={ticketEmailTemplate}
            setTemplate={setTicketEmailTemplate}
            templateSubject={ticketEmailTemplateSubject}
            setTemplateSubject={setTicketEmailTemplateSubject}
            templateContent={ticketEmailTemplateContent}
            setTemplateContent={setTicketEmailTemplateContent}
            emptyContentJson={emptyContentJson}
          />

          <TemplateInput
            key={6}
            name={ShowTemplateType.ConfirmSmsTemplate}
            mailType="Sms"
            templates={templates}
            template={confirmSmsTemplate}
            setTemplate={setConfirmSmsTemplate}
            templateSubject={confirmSmsTemplateSubject}
            setTemplateSubject={setConfirmSmsTemplateSubject}
            templateContent={confirmSmsTemplateContent}
            setTemplateContent={setConfirmSmsTemplateContent}
            emptyContentJson={emptyContentJson}
          />

          <TemplateInput
            key={7}
            name={ShowTemplateType.ReminderSmsTemplate}
            mailType="Sms"
            templates={templates}
            template={reminderSmsTemplate}
            setTemplate={setReminderSmsTemplate}
            templateSubject={reminderSmsTemplateSubject}
            setTemplateSubject={setReminderSmsTemplateSubject}
            templateContent={reminderSmsTemplateContent}
            setTemplateContent={setReminderSmsTemplateContent}
            emptyContentJson={emptyContentJson}
          />

          <Grid container spacing={2} justifyContent="space-between">
            {loadingAssets ? (
              <Grid
                item
                xs={12}
                sx={{ display: "flex", minHeight: 150 }}
                justifyContent="center"
                alignItems="center"
              >
                <CircularProgress />
              </Grid>
            ) : (
              <>
                <Grid item xs={12} sm={!viewModel.objectURL ? 5 : 12}>
                  {!viewModel.objectURL && (
                    <FormControl>
                      <FormLabel htmlFor="image">
                        <input
                          id="image"
                          name="image"
                          type="file"
                          accept="image/jpeg, image/png"
                          hidden
                          onChange={uploadToClient}
                          data-cy="modal-show-banner"
                        />
                        <Fab
                          component="span"
                          size="small"
                          variant="extended"
                          sx={{ pr: 2 }}
                        >
                          <Add /> Add Show Banner
                        </Fab>
                      </FormLabel>
                    </FormControl>
                  )}
                  {!!viewModel.objectURL && (
                    <div className={styles.imageContainer}>
                      <Image
                        src={viewModel.objectURL}
                        layout="fill"
                        objectFit="cover"
                        alt="Show Banner"
                      />
                      <Button variant="contained" onClick={removeImage}>
                        <Remove />
                      </Button>
                    </div>
                  )}
                </Grid>
                <Grid
                  item
                  sx={{ display: "flex" }}
                >
                  {!viewModel.termsAndConditionsObjURL && !viewModel.termsAndConditionsKey && (
                    <FormControl>
                      <FormLabel htmlFor="termsAndConditions">
                        <input
                          id="termsAndConditions"
                          name="termsAndConditions"
                          type="file"
                          accept=".pdf"
                          hidden
                          onChange={uploadTermsToClient}
                          data-cy="modal-show-terms"
                        />
                        <Fab
                          component="span"
                          size="small"
                          variant="extended"
                          sx={{ pr: 2, marginBottom: "1.5rem" }}
                        >
                          <Add />
                          Add Terms and Conditions
                        </Fab>
                      </FormLabel>
                    </FormControl>
                  )}
                  {(!!viewModel.termsAndConditionsObjURL || !!viewModel.termsAndConditionsKey) && (
                    <Box
                      sx={{
                        display: "flex",
                        flex: 1,
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography>Terms and Conditions</Typography>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography
                          sx={{ color: "#1976d2", pr: 5 }}
                          data-cy="modal-show-terms-filename"
                        >
                          {viewModel.termsAndConditions?.name ?? viewModel.termsAndConditionsKey}
                        </Typography>
                        <Button
                          size="small"
                          variant="contained"
                          onClick={removeTermsAndConditions}
                        >
                          <Remove />
                        </Button>
                      </Box>
                    </Box>
                  )}
                </Grid>
              </>
            )}
          </Grid>
          {type === 'edit' ? (getEditShowWarningMessage()) : null}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleDialogClose} data-cy="modal-show-cancel">
            Cancel
          </Button>
          {loading ? (
            <Button
              className={styles.loadingButton}
              type="button"
              variant="contained"
              color="primary"
              disabled={true}
            >
              <CircularProgress />
            </Button>
          ) : (
            <Button
              className={styles.loadingButton}
              disabled={submitDisabled}
              variant="contained"
              onClick={handlePostShow}
              data-cy="modal-show-action"
            >
              {submitMessage}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarErrorOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
          {errorMessage}
        </Alert>
      </Snackbar>
      <Snackbar
        open={snackbarSuccessOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          {successMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default withRouter(CreateShow);
